$(function() {
    $('.js-form-quote').validate({
        submitHandler: function(form) {
            $('.js-quote-request-submit').prop('disabled', true).addClass('is-loading');
            $('.js-quote-request-error').slideUp(150);

            Form.ajaxPost(form, function(data) {
                $('.js-quote-request-submit').prop('disabled', false).removeClass('is-loading');

                if (data.status) {
                    $('.js-quote-request-hide').slideUp(250);
                    $('.js-quote-request-success').slideDown(250);
                } else {
                    $('.js-quote-request-error').html(data.message).slideDown(250);
                }
            }, 'json');
        }
    });

    // $('.c-product-cart__buy form').on('submit', function(event) {
    //     event.preventDefault();

    //     console.log($('.js-custom-forms'));

    //     return false;
    // });

    if ($('.js-custom-forms').length > 0) {
        $(document).on('click', '.products__buy', function(event) {
            let hasError = false;
            let data = {};

            $('.js-custom-forms .c-form__input').each(function() {
                if ($(this).prop('disabled')) {
                    return;
                }

                const isRequiredAndEmpty = $(this).val() == '' && $(this).hasAttr('required');

                $(this).toggleClass('error', isRequiredAndEmpty);

                if (isRequiredAndEmpty) {
                    hasError = true;
                } else {
                    data[$(this).attr('name')] = {
                        label: $(this).siblings('.c-form__label').find('.js-original-label').text(),
                        value: $(this).val(),
                        required: $(this).attr('required'),
                        type: $(this).attr('type')
                    };
                }

            });

            if (data) {
                Cart.moduleData('.c-product-cart__buy [name="module_data"]', 'customForms', data);
            }

            if (hasError) {
                event.preventDefault();

                Eshop.tippyAlert(document.querySelector('.products__buy'), $('.js-custom-forms').attr('data-error-msg'), {
                    theme: 'error'
                });
            }
        });
    }

    $(document).on('keyup keypress', '.js-custom-forms textarea', function() {
        $(this).outerHeight(0);
        $(this).outerHeight(this.scrollHeight >= 92 ? this.scrollHeight : 92);
    });
});